module.exports = __webpack_public_path__ + "img/login.dc9481bd.png";